/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtCompany.id.label': '',
'tqtCompany.id.holder': '请输入',
'tqtCompany.id.max': '最多11个字符',
'tqtCompany.id.required': '必填',
'tqtCompany.searchId.holder': '搜索',
'tqtCompany.name.label': '企业名称',
'tqtCompany.name.holder': '请输入企业名称',
'tqtCompany.name.max': '企业名称最多28个字符',
'tqtCompany.name.required': '企业名称必填',
'tqtCompany.searchName.holder': '搜索企业名称',
'tqtCompany.unifiedSocialCreditCode.label': '统一信用代码',
'tqtCompany.unifiedSocialCreditCode.holder': '请输入统一信用代码',
'tqtCompany.unifiedSocialCreditCode.max': '统一信用代码最多28个字符',
'tqtCompany.unifiedSocialCreditCode.required': '统一信用代码必填',
'tqtCompany.searchUnifiedSocialCreditCode.holder': '搜索统一信用代码',
'tqtCompany.legalman.label': '法人姓名',
'tqtCompany.legalman.holder': '请输入法人姓名',
'tqtCompany.legalman.max': '法人姓名最多10个字符',
'tqtCompany.legalman.required': '法人姓名必填',
'tqtCompany.searchLegalman.holder': '搜索法人姓名',
'tqtCompany.contactMobile.label': '手机号',
'tqtCompany.contactMobile.holder': '请输入手机号',
'tqtCompany.contactMobile.max': '手机号最多18个字符',
'tqtCompany.contactMobile.required': '手机号必填',
'tqtCompany.searchContactMobile.holder': '搜索手机号',
'tqtCompany.buildTime.label': '公司成立日期',
'tqtCompany.buildTime.holder': '请输入公司成立日期',
'tqtCompany.buildTime.max': '公司成立日期最多null个字符',
'tqtCompany.buildTime.required': '公司成立日期必填',
'tqtCompany.searchBuildTime.holder': '搜索公司成立日期',
'tqtCompany.serviceCode.label': '企业信息码路径',
'tqtCompany.serviceCode.holder': '请输入企业信息码路径',
'tqtCompany.serviceCode.max': '企业信息码路径最多58个字符',
'tqtCompany.serviceCode.required': '企业信息码路径必填',
'tqtCompany.searchServiceCode.holder': '搜索企业信息码路径',
'tqtCompany.address.label': '企业详细地址',
'tqtCompany.address.holder': '请输入企业详细地址',
'tqtCompany.address.max': '企业详细地址最多58个字符',
'tqtCompany.address.required': '企业详细地址必填',
'tqtCompany.searchAddress.holder': '搜索企业详细地址',
'tqtCompany.contactMan.label': '联系人',
'tqtCompany.contactMan.holder': '请输入联系人',
'tqtCompany.contactMan.max': '联系人最多10个字符',
'tqtCompany.contactMan.required': '联系人必填',
'tqtCompany.searchContactMan.holder': '搜索联系人',
'tqtCompany.contactManTel.label': '联系人电话',
'tqtCompany.contactManTel.holder': '请输入联系人电话',
'tqtCompany.contactManTel.max': '联系人电话最多11个字符',
'tqtCompany.contactManTel.required': '联系人电话必填',
'tqtCompany.searchContactManTel.holder': '搜索联系人电话',
'tqtCompany.businessRange.label': '经营范围',
'tqtCompany.businessRange.holder': '请输入经营范围',
'tqtCompany.businessRange.max': '经营范围最多18个字符',
'tqtCompany.businessRange.required': '经营范围必填',
'tqtCompany.searchBusinessRange.holder': '搜索经营范围',
'tqtCompany.tel.label': '联系人固定电话',
'tqtCompany.tel.holder': '请输入联系人固定电话',
'tqtCompany.tel.max': '联系人固定电话最多11个字符',
'tqtCompany.tel.required': '联系人固定电话必填',
'tqtCompany.searchTel.holder': '搜索联系人固定电话',
'tqtCompany.email.label': '联系人邮箱',
'tqtCompany.email.holder': '请输入联系人邮箱',
'tqtCompany.email.max': '联系人邮箱最多18个字符',
'tqtCompany.email.required': '联系人邮箱必填',
'tqtCompany.searchEmail.holder': '搜索联系人邮箱',
'tqtCompany.businessLicense.label': '营业执照照片',
'tqtCompany.businessLicense.holder': '请输入营业执照照片',
'tqtCompany.businessLicense.max': '营业执照照片最多54个字符',
'tqtCompany.businessLicense.required': '营业执照照片必填',
'tqtCompany.searchBusinessLicense.holder': '搜索营业执照照片',
'tqtCompany.certificationMaterials.label': '认证材料扫描件',
'tqtCompany.certificationMaterials.holder': '请输入认证材料扫描件',
'tqtCompany.certificationMaterials.max': '认证材料扫描件最多54个字符',
'tqtCompany.certificationMaterials.required': '认证材料扫描件必填',
'tqtCompany.searchCertificationMaterials.holder': '搜索认证材料扫描件',
'tqtCompany.cityCode.label': '市编码',
'tqtCompany.cityCode.holder': '请输入市编码',
'tqtCompany.cityCode.max': '市编码最多54个字符',
'tqtCompany.cityCode.required': '市编码必填',
'tqtCompany.searchCityCode.holder': '搜索市编码',
'tqtCompany.city.label': '市名称',
'tqtCompany.city.holder': '请输入市名称',
'tqtCompany.city.max': '市名称最多54个字符',
'tqtCompany.city.required': '市名称必填',
'tqtCompany.searchCity.holder': '搜索市名称',
'tqtCompany.areaCode.label': '地区编号',
'tqtCompany.areaCode.holder': '请输入地区编号',
'tqtCompany.areaCode.max': '地区编号最多54个字符',
'tqtCompany.areaCode.required': '地区编号必填',
'tqtCompany.searchAreaCode.holder': '搜索地区编号',
'tqtCompany.area.label': '所属地区名称',
'tqtCompany.area.holder': '请输入所属地区名称',
'tqtCompany.area.max': '所属地区名称最多54个字符',
'tqtCompany.area.required': '所属地区名称必填',
'tqtCompany.searchArea.holder': '搜索所属地区名称',
'tqtCompany.townCode.label': '镇编码',
'tqtCompany.townCode.holder': '请输入镇编码',
'tqtCompany.townCode.max': '镇编码最多54个字符',
'tqtCompany.townCode.required': '镇编码必填',
'tqtCompany.searchTownCode.holder': '搜索镇编码',
'tqtCompany.town.label': '镇名称',
'tqtCompany.town.holder': '请输入镇名称',
'tqtCompany.town.max': '镇名称最多54个字符',
'tqtCompany.town.required': '镇名称必填',
'tqtCompany.searchTown.holder': '搜索镇名称',
'tqtCompany.provinceCode.label': '省编码',
'tqtCompany.provinceCode.holder': '请输入省编码',
'tqtCompany.provinceCode.max': '省编码最多54个字符',
'tqtCompany.provinceCode.required': '省编码必填',
'tqtCompany.searchProvinceCode.holder': '搜索省编码',
'tqtCompany.province.label': '省',
'tqtCompany.province.holder': '请输入省',
'tqtCompany.province.max': '省最多54个字符',
'tqtCompany.province.required': '省必填',
'tqtCompany.searchProvince.holder': '搜索省',
'tqtCompany.contactAddress.label': '联系地址',
'tqtCompany.contactAddress.holder': '请输入联系地址',
'tqtCompany.contactAddress.max': '联系地址最多255个字符',
'tqtCompany.contactAddress.required': '联系地址必填',
'tqtCompany.searchContactAddress.holder': '搜索联系地址',
'tqtCompany.sex.label': '法人性别',
'tqtCompany.sex.holder': '请输入法人性别',
'tqtCompany.sex.max': '法人性别最多2个字符',
'tqtCompany.sex.required': '法人性别必填',
'tqtCompany.searchSex.holder': '搜索法人性别',
'tqtCompany.idCard.label': '法人身份证',
'tqtCompany.idCard.holder': '请输入法人身份证',
'tqtCompany.idCard.max': '法人身份证最多18个字符',
'tqtCompany.idCard.required': '法人身份证必填',
'tqtCompany.searchIdCard.holder': '搜索法人身份证',
'tqtCompany.registType.label': '注册类型',
'tqtCompany.registType.holder': '请输入注册类型',
'tqtCompany.registType.max': '注册类型最多255个字符',
'tqtCompany.registType.required': '注册类型必填',
'tqtCompany.searchRegistType.holder': '搜索注册类型',
'tqtCompany.registCapital.label': '注册资金',
'tqtCompany.registCapital.holder': '请输入注册资金',
'tqtCompany.registCapital.max': '注册资金最多255个字符',
'tqtCompany.registCapital.required': '注册资金必填',
'tqtCompany.searchRegistCapital.holder': '搜索注册资金',
'tqtCompany.isorganization.label': '是否服务机构',
'tqtCompany.isorganization.holder': '请输入是否服务机构',
'tqtCompany.isorganization.max': '是否服务机构最多11个字符',
'tqtCompany.isorganization.required': '是否服务机构必填',
'tqtCompany.searchIsorganization.holder': '搜索是否服务机构',
'tqtCompany.cardFront.label': '身份证正面',
'tqtCompany.cardFront.holder': '请输入身份证正面',
'tqtCompany.cardFront.max': '身份证正面最多512个字符',
'tqtCompany.cardFront.required': '身份证正面必填',
'tqtCompany.searchCardFront.holder': '搜索身份证正面',
'tqtCompany.cardBack.label': '身份证反面',
'tqtCompany.cardBack.holder': '请输入身份证反面',
'tqtCompany.cardBack.max': '身份证反面最多512个字符',
'tqtCompany.cardBack.required': '身份证反面必填',
'tqtCompany.searchCardBack.holder': '搜索身份证反面',
'tqtCompany.applyTime.label': '申请时间',
'tqtCompany.applyTime.holder': '请输入申请时间',
'tqtCompany.applyTime.max': '申请时间最多null个字符',
'tqtCompany.applyTime.required': '申请时间必填',
'tqtCompany.searchApplyTime.holder': '搜索申请时间',
},
'zh-TW': {
'tqtCompany.id.label': '',
'tqtCompany.id.holder': '請輸入',
'tqtCompany.id.max': '最多11個字符',
'tqtCompany.id.required': '必填',
'tqtCompany.searchId.holder': '搜索',
'tqtCompany.name.label': '企业名称',
'tqtCompany.name.holder': '請輸入企业名称',
'tqtCompany.name.max': '企业名称最多28個字符',
'tqtCompany.name.required': '企业名称必填',
'tqtCompany.searchName.holder': '搜索企业名称',
'tqtCompany.unifiedSocialCreditCode.label': '统一信用代码',
'tqtCompany.unifiedSocialCreditCode.holder': '請輸入统一信用代码',
'tqtCompany.unifiedSocialCreditCode.max': '统一信用代码最多28個字符',
'tqtCompany.unifiedSocialCreditCode.required': '统一信用代码必填',
'tqtCompany.searchUnifiedSocialCreditCode.holder': '搜索统一信用代码',
'tqtCompany.legalman.label': '法人姓名',
'tqtCompany.legalman.holder': '請輸入法人姓名',
'tqtCompany.legalman.max': '法人姓名最多10個字符',
'tqtCompany.legalman.required': '法人姓名必填',
'tqtCompany.searchLegalman.holder': '搜索法人姓名',
'tqtCompany.contactMobile.label': '手机号',
'tqtCompany.contactMobile.holder': '請輸入手机号',
'tqtCompany.contactMobile.max': '手机号最多18個字符',
'tqtCompany.contactMobile.required': '手机号必填',
'tqtCompany.searchContactMobile.holder': '搜索手机号',
'tqtCompany.buildTime.label': '公司成立日期',
'tqtCompany.buildTime.holder': '請輸入公司成立日期',
'tqtCompany.buildTime.max': '公司成立日期最多null個字符',
'tqtCompany.buildTime.required': '公司成立日期必填',
'tqtCompany.searchBuildTime.holder': '搜索公司成立日期',
'tqtCompany.serviceCode.label': '企业信息码路径',
'tqtCompany.serviceCode.holder': '請輸入企业信息码路径',
'tqtCompany.serviceCode.max': '企业信息码路径最多58個字符',
'tqtCompany.serviceCode.required': '企业信息码路径必填',
'tqtCompany.searchServiceCode.holder': '搜索企业信息码路径',
'tqtCompany.address.label': '企业详细地址',
'tqtCompany.address.holder': '請輸入企业详细地址',
'tqtCompany.address.max': '企业详细地址最多58個字符',
'tqtCompany.address.required': '企业详细地址必填',
'tqtCompany.searchAddress.holder': '搜索企业详细地址',
'tqtCompany.contactMan.label': '联系人',
'tqtCompany.contactMan.holder': '請輸入联系人',
'tqtCompany.contactMan.max': '联系人最多10個字符',
'tqtCompany.contactMan.required': '联系人必填',
'tqtCompany.searchContactMan.holder': '搜索联系人',
'tqtCompany.contactManTel.label': '联系人电话',
'tqtCompany.contactManTel.holder': '請輸入联系人电话',
'tqtCompany.contactManTel.max': '联系人电话最多11個字符',
'tqtCompany.contactManTel.required': '联系人电话必填',
'tqtCompany.searchContactManTel.holder': '搜索联系人电话',
'tqtCompany.businessRange.label': '经营范围',
'tqtCompany.businessRange.holder': '請輸入经营范围',
'tqtCompany.businessRange.max': '经营范围最多18個字符',
'tqtCompany.businessRange.required': '经营范围必填',
'tqtCompany.searchBusinessRange.holder': '搜索经营范围',
'tqtCompany.tel.label': '联系人固定电话',
'tqtCompany.tel.holder': '請輸入联系人固定电话',
'tqtCompany.tel.max': '联系人固定电话最多11個字符',
'tqtCompany.tel.required': '联系人固定电话必填',
'tqtCompany.searchTel.holder': '搜索联系人固定电话',
'tqtCompany.email.label': '联系人邮箱',
'tqtCompany.email.holder': '請輸入联系人邮箱',
'tqtCompany.email.max': '联系人邮箱最多18個字符',
'tqtCompany.email.required': '联系人邮箱必填',
'tqtCompany.searchEmail.holder': '搜索联系人邮箱',
'tqtCompany.businessLicense.label': '营业执照照片',
'tqtCompany.businessLicense.holder': '請輸入营业执照照片',
'tqtCompany.businessLicense.max': '营业执照照片最多54個字符',
'tqtCompany.businessLicense.required': '营业执照照片必填',
'tqtCompany.searchBusinessLicense.holder': '搜索营业执照照片',
'tqtCompany.certificationMaterials.label': '认证材料扫描件',
'tqtCompany.certificationMaterials.holder': '請輸入认证材料扫描件',
'tqtCompany.certificationMaterials.max': '认证材料扫描件最多54個字符',
'tqtCompany.certificationMaterials.required': '认证材料扫描件必填',
'tqtCompany.searchCertificationMaterials.holder': '搜索认证材料扫描件',
'tqtCompany.cityCode.label': '市编码',
'tqtCompany.cityCode.holder': '請輸入市编码',
'tqtCompany.cityCode.max': '市编码最多54個字符',
'tqtCompany.cityCode.required': '市编码必填',
'tqtCompany.searchCityCode.holder': '搜索市编码',
'tqtCompany.city.label': '市名称',
'tqtCompany.city.holder': '請輸入市名称',
'tqtCompany.city.max': '市名称最多54個字符',
'tqtCompany.city.required': '市名称必填',
'tqtCompany.searchCity.holder': '搜索市名称',
'tqtCompany.areaCode.label': '地区编号',
'tqtCompany.areaCode.holder': '請輸入地区编号',
'tqtCompany.areaCode.max': '地区编号最多54個字符',
'tqtCompany.areaCode.required': '地区编号必填',
'tqtCompany.searchAreaCode.holder': '搜索地区编号',
'tqtCompany.area.label': '所属地区名称',
'tqtCompany.area.holder': '請輸入所属地区名称',
'tqtCompany.area.max': '所属地区名称最多54個字符',
'tqtCompany.area.required': '所属地区名称必填',
'tqtCompany.searchArea.holder': '搜索所属地区名称',
'tqtCompany.townCode.label': '镇编码',
'tqtCompany.townCode.holder': '請輸入镇编码',
'tqtCompany.townCode.max': '镇编码最多54個字符',
'tqtCompany.townCode.required': '镇编码必填',
'tqtCompany.searchTownCode.holder': '搜索镇编码',
'tqtCompany.town.label': '镇名称',
'tqtCompany.town.holder': '請輸入镇名称',
'tqtCompany.town.max': '镇名称最多54個字符',
'tqtCompany.town.required': '镇名称必填',
'tqtCompany.searchTown.holder': '搜索镇名称',
'tqtCompany.provinceCode.label': '省编码',
'tqtCompany.provinceCode.holder': '請輸入省编码',
'tqtCompany.provinceCode.max': '省编码最多54個字符',
'tqtCompany.provinceCode.required': '省编码必填',
'tqtCompany.searchProvinceCode.holder': '搜索省编码',
'tqtCompany.province.label': '省',
'tqtCompany.province.holder': '請輸入省',
'tqtCompany.province.max': '省最多54個字符',
'tqtCompany.province.required': '省必填',
'tqtCompany.searchProvince.holder': '搜索省',
'tqtCompany.contactAddress.label': '联系地址',
'tqtCompany.contactAddress.holder': '請輸入联系地址',
'tqtCompany.contactAddress.max': '联系地址最多255個字符',
'tqtCompany.contactAddress.required': '联系地址必填',
'tqtCompany.searchContactAddress.holder': '搜索联系地址',
'tqtCompany.sex.label': '法人性别',
'tqtCompany.sex.holder': '請輸入法人性别',
'tqtCompany.sex.max': '法人性别最多2個字符',
'tqtCompany.sex.required': '法人性别必填',
'tqtCompany.searchSex.holder': '搜索法人性别',
'tqtCompany.idCard.label': '法人身份证',
'tqtCompany.idCard.holder': '請輸入法人身份证',
'tqtCompany.idCard.max': '法人身份证最多18個字符',
'tqtCompany.idCard.required': '法人身份证必填',
'tqtCompany.searchIdCard.holder': '搜索法人身份证',
'tqtCompany.registType.label': '注册类型',
'tqtCompany.registType.holder': '請輸入注册类型',
'tqtCompany.registType.max': '注册类型最多255個字符',
'tqtCompany.registType.required': '注册类型必填',
'tqtCompany.searchRegistType.holder': '搜索注册类型',
'tqtCompany.registCapital.label': '注册资金',
'tqtCompany.registCapital.holder': '請輸入注册资金',
'tqtCompany.registCapital.max': '注册资金最多255個字符',
'tqtCompany.registCapital.required': '注册资金必填',
'tqtCompany.searchRegistCapital.holder': '搜索注册资金',
'tqtCompany.isorganization.label': '是否服务机构',
'tqtCompany.isorganization.holder': '請輸入是否服务机构',
'tqtCompany.isorganization.max': '是否服务机构最多11個字符',
'tqtCompany.isorganization.required': '是否服务机构必填',
'tqtCompany.searchIsorganization.holder': '搜索是否服务机构',
'tqtCompany.cardFront.label': '身份证正面',
'tqtCompany.cardFront.holder': '請輸入身份证正面',
'tqtCompany.cardFront.max': '身份证正面最多512個字符',
'tqtCompany.cardFront.required': '身份证正面必填',
'tqtCompany.searchCardFront.holder': '搜索身份证正面',
'tqtCompany.cardBack.label': '身份证反面',
'tqtCompany.cardBack.holder': '請輸入身份证反面',
'tqtCompany.cardBack.max': '身份证反面最多512個字符',
'tqtCompany.cardBack.required': '身份证反面必填',
'tqtCompany.searchCardBack.holder': '搜索身份证反面',
'tqtCompany.applyTime.label': '申请时间',
'tqtCompany.applyTime.holder': '請輸入申请时间',
'tqtCompany.applyTime.max': '申请时间最多null個字符',
'tqtCompany.applyTime.required': '申请时间必填',
'tqtCompany.searchApplyTime.holder': '搜索申请时间',
},
'en-US': {
'tqtCompany.id.label': '',
'tqtCompany.id.holder': 'Enter ',
'tqtCompany.id.max': ' max length: 11',
'tqtCompany.id.required': ' required',
'tqtCompany.searchId.holder': 'Search ',
'tqtCompany.name.label': '企业名称',
'tqtCompany.name.holder': 'Enter 企业名称',
'tqtCompany.name.max': '企业名称 max length: 28',
'tqtCompany.name.required': '企业名称 required',
'tqtCompany.searchName.holder': 'Search 企业名称',
'tqtCompany.unifiedSocialCreditCode.label': '统一信用代码',
'tqtCompany.unifiedSocialCreditCode.holder': 'Enter 统一信用代码',
'tqtCompany.unifiedSocialCreditCode.max': '统一信用代码 max length: 28',
'tqtCompany.unifiedSocialCreditCode.required': '统一信用代码 required',
'tqtCompany.searchUnifiedSocialCreditCode.holder': 'Search 统一信用代码',
'tqtCompany.legalman.label': '法人姓名',
'tqtCompany.legalman.holder': 'Enter 法人姓名',
'tqtCompany.legalman.max': '法人姓名 max length: 10',
'tqtCompany.legalman.required': '法人姓名 required',
'tqtCompany.searchLegalman.holder': 'Search 法人姓名',
'tqtCompany.contactMobile.label': '手机号',
'tqtCompany.contactMobile.holder': 'Enter 手机号',
'tqtCompany.contactMobile.max': '手机号 max length: 18',
'tqtCompany.contactMobile.required': '手机号 required',
'tqtCompany.searchContactMobile.holder': 'Search 手机号',
'tqtCompany.buildTime.label': '公司成立日期',
'tqtCompany.buildTime.holder': 'Enter 公司成立日期',
'tqtCompany.buildTime.max': '公司成立日期 max length: null',
'tqtCompany.buildTime.required': '公司成立日期 required',
'tqtCompany.searchBuildTime.holder': 'Search 公司成立日期',
'tqtCompany.serviceCode.label': '企业信息码路径',
'tqtCompany.serviceCode.holder': 'Enter 企业信息码路径',
'tqtCompany.serviceCode.max': '企业信息码路径 max length: 58',
'tqtCompany.serviceCode.required': '企业信息码路径 required',
'tqtCompany.searchServiceCode.holder': 'Search 企业信息码路径',
'tqtCompany.address.label': '企业详细地址',
'tqtCompany.address.holder': 'Enter 企业详细地址',
'tqtCompany.address.max': '企业详细地址 max length: 58',
'tqtCompany.address.required': '企业详细地址 required',
'tqtCompany.searchAddress.holder': 'Search 企业详细地址',
'tqtCompany.contactMan.label': '联系人',
'tqtCompany.contactMan.holder': 'Enter 联系人',
'tqtCompany.contactMan.max': '联系人 max length: 10',
'tqtCompany.contactMan.required': '联系人 required',
'tqtCompany.searchContactMan.holder': 'Search 联系人',
'tqtCompany.contactManTel.label': '联系人电话',
'tqtCompany.contactManTel.holder': 'Enter 联系人电话',
'tqtCompany.contactManTel.max': '联系人电话 max length: 11',
'tqtCompany.contactManTel.required': '联系人电话 required',
'tqtCompany.searchContactManTel.holder': 'Search 联系人电话',
'tqtCompany.businessRange.label': '经营范围',
'tqtCompany.businessRange.holder': 'Enter 经营范围',
'tqtCompany.businessRange.max': '经营范围 max length: 18',
'tqtCompany.businessRange.required': '经营范围 required',
'tqtCompany.searchBusinessRange.holder': 'Search 经营范围',
'tqtCompany.tel.label': '联系人固定电话',
'tqtCompany.tel.holder': 'Enter 联系人固定电话',
'tqtCompany.tel.max': '联系人固定电话 max length: 11',
'tqtCompany.tel.required': '联系人固定电话 required',
'tqtCompany.searchTel.holder': 'Search 联系人固定电话',
'tqtCompany.email.label': '联系人邮箱',
'tqtCompany.email.holder': 'Enter 联系人邮箱',
'tqtCompany.email.max': '联系人邮箱 max length: 18',
'tqtCompany.email.required': '联系人邮箱 required',
'tqtCompany.searchEmail.holder': 'Search 联系人邮箱',
'tqtCompany.businessLicense.label': '营业执照照片',
'tqtCompany.businessLicense.holder': 'Enter 营业执照照片',
'tqtCompany.businessLicense.max': '营业执照照片 max length: 54',
'tqtCompany.businessLicense.required': '营业执照照片 required',
'tqtCompany.searchBusinessLicense.holder': 'Search 营业执照照片',
'tqtCompany.certificationMaterials.label': '认证材料扫描件',
'tqtCompany.certificationMaterials.holder': 'Enter 认证材料扫描件',
'tqtCompany.certificationMaterials.max': '认证材料扫描件 max length: 54',
'tqtCompany.certificationMaterials.required': '认证材料扫描件 required',
'tqtCompany.searchCertificationMaterials.holder': 'Search 认证材料扫描件',
'tqtCompany.cityCode.label': '市编码',
'tqtCompany.cityCode.holder': 'Enter 市编码',
'tqtCompany.cityCode.max': '市编码 max length: 54',
'tqtCompany.cityCode.required': '市编码 required',
'tqtCompany.searchCityCode.holder': 'Search 市编码',
'tqtCompany.city.label': '市名称',
'tqtCompany.city.holder': 'Enter 市名称',
'tqtCompany.city.max': '市名称 max length: 54',
'tqtCompany.city.required': '市名称 required',
'tqtCompany.searchCity.holder': 'Search 市名称',
'tqtCompany.areaCode.label': '地区编号',
'tqtCompany.areaCode.holder': 'Enter 地区编号',
'tqtCompany.areaCode.max': '地区编号 max length: 54',
'tqtCompany.areaCode.required': '地区编号 required',
'tqtCompany.searchAreaCode.holder': 'Search 地区编号',
'tqtCompany.area.label': '所属地区名称',
'tqtCompany.area.holder': 'Enter 所属地区名称',
'tqtCompany.area.max': '所属地区名称 max length: 54',
'tqtCompany.area.required': '所属地区名称 required',
'tqtCompany.searchArea.holder': 'Search 所属地区名称',
'tqtCompany.townCode.label': '镇编码',
'tqtCompany.townCode.holder': 'Enter 镇编码',
'tqtCompany.townCode.max': '镇编码 max length: 54',
'tqtCompany.townCode.required': '镇编码 required',
'tqtCompany.searchTownCode.holder': 'Search 镇编码',
'tqtCompany.town.label': '镇名称',
'tqtCompany.town.holder': 'Enter 镇名称',
'tqtCompany.town.max': '镇名称 max length: 54',
'tqtCompany.town.required': '镇名称 required',
'tqtCompany.searchTown.holder': 'Search 镇名称',
'tqtCompany.provinceCode.label': '省编码',
'tqtCompany.provinceCode.holder': 'Enter 省编码',
'tqtCompany.provinceCode.max': '省编码 max length: 54',
'tqtCompany.provinceCode.required': '省编码 required',
'tqtCompany.searchProvinceCode.holder': 'Search 省编码',
'tqtCompany.province.label': '省',
'tqtCompany.province.holder': 'Enter 省',
'tqtCompany.province.max': '省 max length: 54',
'tqtCompany.province.required': '省 required',
'tqtCompany.searchProvince.holder': 'Search 省',
'tqtCompany.contactAddress.label': '联系地址',
'tqtCompany.contactAddress.holder': 'Enter 联系地址',
'tqtCompany.contactAddress.max': '联系地址 max length: 255',
'tqtCompany.contactAddress.required': '联系地址 required',
'tqtCompany.searchContactAddress.holder': 'Search 联系地址',
'tqtCompany.sex.label': '法人性别',
'tqtCompany.sex.holder': 'Enter 法人性别',
'tqtCompany.sex.max': '法人性别 max length: 2',
'tqtCompany.sex.required': '法人性别 required',
'tqtCompany.searchSex.holder': 'Search 法人性别',
'tqtCompany.idCard.label': '法人身份证',
'tqtCompany.idCard.holder': 'Enter 法人身份证',
'tqtCompany.idCard.max': '法人身份证 max length: 18',
'tqtCompany.idCard.required': '法人身份证 required',
'tqtCompany.searchIdCard.holder': 'Search 法人身份证',
'tqtCompany.registType.label': '注册类型',
'tqtCompany.registType.holder': 'Enter 注册类型',
'tqtCompany.registType.max': '注册类型 max length: 255',
'tqtCompany.registType.required': '注册类型 required',
'tqtCompany.searchRegistType.holder': 'Search 注册类型',
'tqtCompany.registCapital.label': '注册资金',
'tqtCompany.registCapital.holder': 'Enter 注册资金',
'tqtCompany.registCapital.max': '注册资金 max length: 255',
'tqtCompany.registCapital.required': '注册资金 required',
'tqtCompany.searchRegistCapital.holder': 'Search 注册资金',
'tqtCompany.isorganization.label': '是否服务机构',
'tqtCompany.isorganization.holder': 'Enter 是否服务机构',
'tqtCompany.isorganization.max': '是否服务机构 max length: 11',
'tqtCompany.isorganization.required': '是否服务机构 required',
'tqtCompany.searchIsorganization.holder': 'Search 是否服务机构',
'tqtCompany.cardFront.label': '身份证正面',
'tqtCompany.cardFront.holder': 'Enter 身份证正面',
'tqtCompany.cardFront.max': '身份证正面 max length: 512',
'tqtCompany.cardFront.required': '身份证正面 required',
'tqtCompany.searchCardFront.holder': 'Search 身份证正面',
'tqtCompany.cardBack.label': '身份证反面',
'tqtCompany.cardBack.holder': 'Enter 身份证反面',
'tqtCompany.cardBack.max': '身份证反面 max length: 512',
'tqtCompany.cardBack.required': '身份证反面 required',
'tqtCompany.searchCardBack.holder': 'Search 身份证反面',
'tqtCompany.applyTime.label': '申请时间',
'tqtCompany.applyTime.holder': 'Enter 申请时间',
'tqtCompany.applyTime.max': '申请时间 max length: null',
'tqtCompany.applyTime.required': '申请时间 required',
'tqtCompany.searchApplyTime.holder': 'Search 申请时间',
}
};